import React, {useRef, useState} from "react";
import axios from "axios";
import apiUrl from "../../shared/config";
import {ThumbUp, ThumbDown} from "@material-ui/icons";
import {Tooltip} from "@material-ui/core";
import {AnimatePresence, motion} from 'framer-motion';
import {findAssessment} from "../../utils/voteUtils";
import "./PatternVote.css";
import PresetModal from "../UI/Modal/PresetModal/PresetModal";
import Auth from "../../containers/Auth/Auth";
import IconWithHover from "../IconButtons/IconWithHover/IconWithHover";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

export default function PatternVote({user_vote, up_votes, down_votes, update, token, pattern_id}) {
    const percent = up_votes / (up_votes + down_votes) * 100;
    const totalVotes = up_votes + down_votes;
    const loginModal = useRef();
    const [isLoading, setIsLoading] = useState(false)


    const flexGap = (gap) => {return {display: "flex", gap: gap,}}

    function sendVote(vote) {
        if (token) {
            setIsLoading(true)
            axios.get(apiUrl + "Vote/vote?vote=" + vote + "&token=" + token + "&primary_id=" + pattern_id + '&vote_type=PATTERN').then(() => setIsLoading(false))
                .then(update).catch(() => {
                    setIsLoading(false)
                    console.log("Vote Failed")
                });
        } else {
            loginModal.current.open();
        }
    }

    const thumbsUpVoteValue = user_vote?.vote_type === 1 ? 0 : 1
    const thumbsDownVoteValue = user_vote?.vote_type === -1 ? 0 : -1

    const confirmVotePopover = {
        title: <b style={{fontSize: 16}}>Confirm Your Rating</b>,
        text: <div style={{fontSize: 14}}>A pattern you left a <b>{user_vote?.vote_type === 1 ? 'Positive' : 'Negative'}</b> rating on has been
            merged to create this pattern. <br/>
            <div style={{
                paddingTop: 10,
                float: "right",
                paddingBottom: 15
            }}>
                {isLoading &&
                    <Spinner animation={'border'} style={{width: 30, height: 30, marginBottom: -10, marginRight: 10}}/>}
                <Button className={'preset-modal-button-button'} style={{fontSize: 14}} onClick={() => sendVote(user_vote?.vote_type || 0)}>Confirm
                    Rating</Button>
                <Button className={'preset-modal-cancel-button'} onClick={() => sendVote(0)}
                        style={{marginLeft: 10, fontSize: 14}}>Remove Rating</Button>
            </div>
        </div>
    }

    const confirmStyles = user_vote?.auto_vote === 1 ? {borderColor: 'orange', borderWidth: '2px'} : {}


    const assessment = totalVotes === 0 ? { assess: "None", color: "gray" } : findAssessment(percent, totalVotes);

    const voteBox = (
                <motion.div className="pattern-vote" style={{marginTop: 15, marginBottom: 15, ...confirmStyles}}>
                    <motion.div style={{...flexGap(10), color:"black"}}>
                        <motion.div style={flexGap(10)}>
                            <Tooltip title="Agree" placement="top">
                                <motion.div whileTap={{scale: 1.2, rotate: [0, -15, 0, 15, 0]}}
                                            style={{fontWeight: "normal", color: "black", alignItems: "center"}}
                                            transition={{type: "spring", stiffness: 300, damping: 10, duration: 0.5}}>
                                    <ThumbUp onClick={() => {
                                        sendVote(thumbsUpVoteValue)
                                    }} color={user_vote?.vote_type === 1 ? "inherit" : "action"}/>
                                </motion.div>
                            </Tooltip>
                            <Tooltip title="Disagree" placement="top">
                                <motion.div whileTap={{scale: 1.2, rotate: [0, -15, 0, 15, 0]}}
                                            style={{fontWeight: "normal", color: "black", alignItems: "center"}}
                                            transition={{type: "spring", stiffness: 300, damping: 10, duration: 0.5,}}>
                                    <ThumbDown onClick={() => {
                                        sendVote(thumbsDownVoteValue)
                                    }} color={user_vote?.vote_type === -1 ? "inherit" : "action"}/>
                                </motion.div>
                            </Tooltip>
                        </motion.div>
                        Total Votes:
                        <AnimatePresence exitBeforeEnter>
                            <motion.p key={`${totalVotes}-num`}
                                      initial={{opacity: 0}}
                                      animate={{opacity: 1,}}
                                      exit={{opacity: 0}}
                                      transition={{duration: 0.3, ease: "easeInOut"}}
                                      style={{marginBottom: 0, color: "gray"}}
                            >{totalVotes}</motion.p>
                        </AnimatePresence>
                    </motion.div>
                    <div style={{...flexGap(8), marginBottom: 0}}>
                        <div style={{color: "black"}}>Assessment:</div>
                        <AnimatePresence exitBeforeEnter>
                            <motion.div
                                key={assessment.assess}
                                initial={{opacity: 0, color: assessment.color}}
                                animate={{opacity: 1, color: assessment.color}}
                                exit={{opacity: 0}}
                                transition={{duration: 0.3, ease: "easeInOut"}}
                            >
                                {assessment.assess}
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </motion.div>
    );

    return <>
        <AnimatePresence initial={false} presenceAffectsLayout={false}>
            {user_vote?.auto_vote ? <IconWithHover direction={'top'} icon={voteBox} popoverContent={confirmVotePopover}/> : voteBox}
        </AnimatePresence>
        <PresetModal ref={loginModal} title={"Login to Rate this Pattern"}><Auth shouldRedirect hideDragon/></PresetModal>
    </>
}
